<template>
  <div>
    <nav-breadcrumb :menu="[{label: ' 转账导入日志'}]"/>
    <div class="xzpadd10 bg-purple of">
      <data-table
        :table-data="tableData"
        :columns="columns"
        :page.sync="page"
        :pageSize.sync="pageSize"
        :filters.sync="filters"
        :actions="actions"
      />
    </div>
  </div>
</template>

<script>
  import xhr from '../../utils/xhr'
  import {xmlBuildQuery} from "../../filters/CommonActions";
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Constant from '../../utils/constant'
  import bankTypeOptions from "../../utils/bankTypeOptions"
    export default {
        name: "ImportBankTallyLogList",
      data(){
        return{
          columns:[
            {
              type: 'index'
            },
            {
              label: '所属银行',
              field: 't__bankCode',
              formatter: function (r,c,v) {
                return Status2CN(v)
              }
            },
            {
              label: '导入时间',
              field: 't__createdDate',
              formatter: function (r,c,v) {
                if(v)
                  return moment(v).format('YYYY-MM-DD HH:mm:ss')
              }
            },

            {
              label: '导入人',
              field: 'u__userName',
            },
            {
              label: '文件名称',
              field: 'f__name'
            },
            {
              label: '文件大小',
              field: 'f__size',
              formatter: function (r,c,v) {
                if(v)
                return (parseFloat(v)/1024).toFixed(2)+'kb'
              }
            },
            {
              label: '操作',
              opts:[
                {
                  label: '下载',
                  class: 'el-icon-download',
                  clickHandler: (index, row)=> {
                    let fileUri = Constant.SERVER_BASE_URL + '/files/'+row.f__fileId+'/!/'+row.f__name
                    window.open( fileUri )
                  },
                  conditions: row=> {
                    return row.f__fileId&&row.f__name
                  }
                },
              ]
            }
          ],
          tableData: {
            count: 0,
            data: []
          },
          dealerTypeOptions:[],
          page: 1,
          pageSize: 20,
          actions: [
          ],
          filters: {
            labelWidth: '150px',
            form: {
                t__bankCode:'',
              t__createdDate:[],
            },
            columns: [
              {
                label: '所属银行',
                component: 'el-select',
                field: 't__bankCode',
                options:[
                  {
                    label:'兴业银行',
                    value:'CIB'
                  },
                    {
                        label:'招商银行',
                        value:'CMB'
                    }
                ],
              },
              {
                label: '导入日期',
                component: 'date-range-picker',
                field: 't__createdDate',
                op: ['gteq', 'lteq'],
                dateFormat: ['yyyy-MM-dd 00:00:00','yyyy-MM-dd 23:59:59'],
                span: 12
              },

            ],
            onSubmit:()=>{
              this.page = 1
              this.getData()
            }
          }
        }
      },
      mounted() {
        this.getData()
      },
      computed: {
        filterParams() {
          return {
            pageSize: this.pageSize,
            pageOffset: (this.page - 1) * this.pageSize,
          }
        }
      },
      watch: {
        filterParams: function (newVal) {
          this.getData()
        }
      },
      methods: {
        getData: function () {
          xhr.getBankStatementList(
            Object.assign({}, this.filterParams, xmlBuildQuery(this.filters)),
            res=> {
              try {
                this.tableData = res.data
              }catch(e){

              }
            })

        },
      }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ImportBankTallyLogList.vue